<template>
  <div class="slider-steps flex items-center w-full">
    <div
      class="big-step"
      v-for="(product, indexProduct) in products"
      :key="indexProduct"
      :style="stepWidthStyle(products.length)"
      :class="{ active: bigStepIndexActive == indexProduct }"
    >
      <div class="step-boxs flex items-center w-full">
        <div
          v-for="(step, indexStep) in product.children"
          :key="indexStep"
          :style="stepWidthStyle(product.children.length)"
          class="small-step"
          :class="{ active: activeStepIdLocal == step.id }"
          @click="onClickSmallStep(step)"
        ></div>
      </div>

      <div class="step-text cursor-pointer mt-10" @click="onClickBigStep(indexProduct)">
        <div v-if="textSteps && textSteps[indexProduct]" class="step-title text-black text-base">
          {{ textSteps[indexProduct] }} {{ product.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'

export default defineComponent({
  emits: ['click'],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    activeStepId: {
      type: String,
      default: '',
    },
    textSteps: {
      type: [Array],
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { products, activeStepId } = props

    /**
     * @property {String}
     * @description Return step id active
     */
    const activeStepIdLocal = ref('')
    activeStepIdLocal.value = activeStepId

    /**
     * @description When click small step, get current item and emit id
     */
    const onClickSmallStep = (step: { active: boolean; id: string }) => {
      activeStepIdLocal.value = step.id
      emit('click', step.id)
    }

    /**
     * @description When click big step, will get first item of big step and emit id
     */
    const onClickBigStep = (indexModule: number) => {
      const moduleActive: any = products[indexModule]
      activeStepIdLocal.value = moduleActive.children[0].id
      emit('click', activeStepIdLocal.value)
    }

    /**
     * @property {String}
     * @description Computed big step index active and compare to font-weight step title
     */
    const bigStepIndexActive = computed(() => {
      let index = 0
      products.forEach((product: any, indexProduct) => {
        product.children.forEach((el: any) => {
          if (el.id == activeStepIdLocal.value) {
            index = indexProduct
          }
        })
      })
      return index
    })

    /**
     * @property {String}
     * @description Calculate and style width of step by length step
     */
    const stepWidthStyle = (stepLength: number) => {
      return {
        width: `${100 / stepLength}%`,
      }
    }

    watch(
      /**
       * @description active current step
       */
      () => props.activeStepId,
      (newValue: string) => {
        activeStepIdLocal.value = newValue
      },
    )

    return {
      stepWidthStyle,
      activeStepIdLocal,
      onClickSmallStep,
      bigStepIndexActive,
      onClickBigStep,
    }
  },
})
</script>
<style scoped>
.big-step {
  @apply mr-2 md:mr-4 flex items-start flex-col last:mr-0 font-semibold;
}

.small-step {
  @apply mr-1 md:mr-2 border-black border-t w-auto cursor-pointer last:mr-0 transition duration-300 ease-in-out;
}
.small-step.active {
  @apply border-t-3;
}
</style>
